import { authKeys } from '@/hooks/use-auth';
import { ApiError } from '@/lib/api/client';
import { createTenant, deleteCurrentTenant, updateCurrentTenant } from '@/lib/api/tenants';
import type { CreateTenantInput, DeleteTenantInput, UpdateTenantInput } from '@disparos/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

function extractErrorMessage(err: unknown): string {
  if (
    err instanceof ApiError &&
    typeof err.body === 'object' &&
    err.body !== null &&
    'message' in err.body
  ) {
    return String((err.body as { message: unknown }).message);
  }
  return err instanceof Error ? err.message : 'Erro desconhecido';
}

export function useCreateTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTenantInput) => createTenant(input),
    onSuccess: () => {
      // Invalida /me — UI pega memberships atualizadas com a nova workspace.
      // Switch automático fica a cargo do caller (queremos UX que pergunte).
      void qc.invalidateQueries({ queryKey: authKeys.me() });
    },
    onError: (err) => {
      toast.error(extractErrorMessage(err));
    },
  });
}

export function useUpdateCurrentTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTenantInput) => updateCurrentTenant(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: authKeys.me() });
    },
    onError: (err) => {
      toast.error(extractErrorMessage(err));
    },
  });
}

export function useDeleteCurrentTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: DeleteTenantInput) => deleteCurrentTenant(input),
    onSuccess: () => {
      // Tenant ativo deixou de existir — `sessions.currentTenantId` foi
      // anulada via FK SET NULL. Plugin auth resolve fallback pra primeira
      // membership disponível. Cleared cache + reload garante UI consistente.
      qc.clear();
      window.location.reload();
    },
    onError: (err) => {
      toast.error(extractErrorMessage(err));
    },
  });
}
